// extracted by mini-css-extract-plugin
module.exports = {"diningData":"dining-data-module--diningData--1ALK9","diningDataItem":"dining-data-module--diningDataItem--FzZ_5"};